export default defineNuxtPlugin(() => {
    const route = useRoute()
    const runtimeConfig = useRuntimeConfig()

    function persistAwinCookies(awc: string) {
        const ttlDays = Number(runtimeConfig.public.awinTrackingCookieTtl) || 61
        const cookieTtl = new Date(
            Date.now() + ttlDays * 24 * 60 * 60 * 1000
        )

        const affiliateSource = useCookie('affiliateSource', {
            path: '/',
            expires: cookieTtl,
            sameSite: 'lax'
        })
        affiliateSource.value = 'aw'

        const awinAwc = useCookie('awinAwc', {
            path: '/',
            expires: cookieTtl,
            sameSite: 'lax'
        })
        awinAwc.value = awc
    }

    function removeAwinCookies() {
        const affiliateSource = useCookie('affiliateSource')
        affiliateSource.value = null
        const awinAwc = useCookie('awinAwc')
        awinAwc.value = null
    }

    let pendingAwc: string | null = null

    type CookieFirstWindow = { consent?: { advertising?: boolean } } | undefined
    const getCookieFirst = () => (window as unknown as Record<string, unknown>).CookieFirst as CookieFirstWindow

    function applyConsent(advertising: boolean | undefined) {
        if (advertising === true) {
            if (pendingAwc) {
                persistAwinCookies(pendingAwc)
            }
        } else {
            removeAwinCookies()
        }
    }

    // Always registered — handles consent changes that affect existing Awin cookies
    window.addEventListener('cf_consent', (event: Event) => {
        const consent = (event as CustomEvent<{ advertising?: boolean }>).detail
        applyConsent(consent?.advertising)
    })

    // awc is only present on the initial Awin landing URL
    if (route.query.awc) {
        const awc = Array.isArray(route.query.awc) ? route.query.awc[0] : route.query.awc
        if (awc) {
            pendingAwc = awc

            // CookieFirst already initialized before plugin ran — apply immediately
            // Otherwise register cf_init as fallback
            if (getCookieFirst()?.consent !== undefined) {
                applyConsent(getCookieFirst()?.consent?.advertising)
            } else {
                window.addEventListener('cf_init', function() {
                    applyConsent(getCookieFirst()?.consent?.advertising)
                }, { once: true })
            }
        }
    }
})
